import { Action } from '../../common/actions/core/action'

export class OpenYearlyAction implements Action {
  constructor(public onApprove: () => any) {}
}



// WEBPACK FOOTER //
// src/app/buy/yearly-info/yearly-dialog.action.ts